import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import type StateService from 'garaje/services/state';
import { isBillingFeatureEnabled } from 'garaje/utils/billing-features';

export interface BillingFeatureEnabledSignature {
  Args: {
    Positional: [featureName: string];
  };
  Return: boolean;
}

/**
 * Template-side wrapper for `isBillingFeatureEnabled`. Determines whether the current scope's
 * billing subscription includes the given feature.
 *
 * Feature names are the snake_case strings the billing endpoint returns
 * (e.g. "threat_dashboard", "analytics").
 *
 * Companion to `feature-enabled` (Split) and `config-enabled` (GraphQL featureConfig).
 *
 * Usage: {{#if (billing-feature-enabled "threat_dashboard")}}
 */
export default class BillingFeatureEnabled extends Helper<BillingFeatureEnabledSignature> {
  @service declare state: StateService;

  compute([feature]: BillingFeatureEnabledSignature['Args']['Positional']): BillingFeatureEnabledSignature['Return'] {
    return isBillingFeatureEnabled(feature, this.state);
  }
}
